<form [formGroup]="form" class="formgrid grid">
  <div class="field col-12">
    <label>Rechnungsanschrift</label>
    <div class="flex flex-wrap gap-3 mb-3">
      <div class="flex align-items-center">
        <p-radioButton
          [value]="true"
          formControlName="inherit"
          inputId="inheritBillingAddressInputTrue"
        ></p-radioButton>
        <label for="inheritBillingAddressInputTrue" class="ml-2">Wie Auftraggeber</label>
      </div>
      <div class="flex align-items-center">
        <p-radioButton
          [value]="false"
          formControlName="inherit"
          inputId="inheritBillingAddressInputFalse"
        ></p-radioButton>
        <label for="inheritBillingAddressInputFalse" class="ml-2">Neue Angabe</label>
      </div>
    </div>
  </div>
  <ng-container *ngIf="showAddressFields()">
    <div class="field col-12">
      <label for="titleInput">Anrede<ow-validation-mark [control]="form.controls.title"></ow-validation-mark></label>
      <p-dropdown
        inputId="titleInput"
        formControlName="title"
        [options]="TITLE_OPTIONS"
        placeholder="Anrede"
        styleClass="w-full"
      ></p-dropdown>
    </div>
    <div class="field col-12">
      <label for="firstNameInput"
        >Vorname<ow-validation-mark [control]="form.controls.firstName"></ow-validation-mark
      ></label>
      <input type="text" pInputText id="firstNameInput" formControlName="firstName" class="w-full" />
    </div>
    <div class="field col-12">
      <label for="lastNameInput"
        >Nachname<ow-validation-mark [control]="form.controls.lastName"></ow-validation-mark
      ></label>
      <input type="text" pInputText id="lastNameInput" formControlName="lastName" class="w-full" />
    </div>
    <div class="field col-12 md:col-9">
      <label for="streetNameInput"
        >Straße<ow-validation-mark [control]="form.controls.streetName"></ow-validation-mark
      ></label>
      <input type="text" pInputText id="streetNameInput" formControlName="streetName" class="w-full" />
    </div>
    <div class="field col-12 md:col-3">
      <label for="streetNumberInput"
        >Hausnr<ow-validation-mark [control]="form.controls.streetNumber"></ow-validation-mark
      ></label>
      <input type="text" pInputText id="streetNumberInput" formControlName="streetNumber" class="w-full" />
    </div>
    <div class="field col-12 md:col-3">
      <label for="postalCodeInput"
        >PLZ<ow-validation-mark [control]="form.controls.postalCode"></ow-validation-mark
      ></label>
      <input type="text" pInputText id="postalCodeInput" formControlName="postalCode" class="w-full" />
    </div>
    <div class="field col-12 md:col-9">
      <label for="cityInput">Ort<ow-validation-mark [control]="form.controls.city"></ow-validation-mark></label>
      <input type="text" pInputText id="cityInput" formControlName="city" class="w-full" />
    </div>
  </ng-container>
</form>
